var map = {
	"./like.png": "d525",
	"./message.png": "555a",
	"./news.png": "9e22",
	"./photoSlider.png": "f47c",
	"./player.png": "fe8f",
	"./profile.png": "38f5",
	"./record.png": "744b",
	"./search.png": "4414",
	"./share.png": "47ab",
	"./videoSlider.png": "980e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b13";